<div class="relative w-full">
  @if (label) {
  <label class="text-sm font-medium text-metro-black mb-1 block">
    {{ label | abpLocalization }}
  </label>
  }
  <input
    [type]="type === 'password' ? (showPassword ? 'text' : 'password') : type"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [value]="value"
    [autocomplete]="autocomplete"
    [id]="id"
    (input)="handleInputChange($event)"
    (blur)="onTouched()"
    [ngClass]="{
      'text-sm px-2 py-1': size === 'sm',
      'text-base px-3 py-2': size === 'md',
      'text-lg px-4 py-3': size === 'lg',
      'border-red-500 ring-1 ring-red-400': error,
      'border-transparent': !error,
      'cursor-not-allowed opacity-60': disabled
    }"
    class="block w-full input-base placeholder-metro-blue-secondary placeholder-opacity-50 pr-10"
  />

  <button
    *ngIf="type === 'password'"
    (click)="togglePassword()"
    type="button"
    class="absolute inset-y-0 right-0 px-2 flex items-center bg-metro-secondary rounded-r-md cursor-pointer transition"
  >
    <app-metro-icon
      [svg]="showPassword ? APP_ICONS.eyeOff : APP_ICONS.eye"
      size="20"
      color="#0e161b"
    ></app-metro-icon>
  </button>


  <p
    *ngIf="error"
    class="absolute left-0 top-full text-[10px] text-red-500 mt-0.5 leading-none"
  >
    {{ error | abpLocalization }}
  </p>

  <p
    *ngIf="helper && !error"
    class="absolute left-0 top-full text-[10px] text-metro-blue mt-0.5 leading-none"
  >
    {{ helper | abpLocalization }}
  </p>
</div>
